module.exports = __webpack_public_path__ + "media/images/icon-wand-099af257d43367996e568b6617c4021d.svg";